import { useState } from "react";
import axios from "axios";
import { API, SYMBOLS } from "../config/trading";
import { apiErrorMessage } from "../lib/errorMessage";

export function useBotAndRiskActions({ dashboard, selectedSymbol, risk, setDashboard, loadDashboard, setOrderMessage }) {
  const [botBusy, setBotBusy] = useState(false);

  const toggleBot = async () => {
    if (!dashboard) return;
    setBotBusy(true);
    try {
      const response = await axios.post(`${API}/bot/toggle`, { enabled: !dashboard.bot.enabled, selected_symbol: selectedSymbol });
      setDashboard((current) => ({ ...current, bot: response.data }));
      await loadDashboard();
    } catch (err) {
      setOrderMessage(apiErrorMessage(err, "Bot state could not be changed."));
    } finally {
      setBotBusy(false);
    }
  };

  const saveRisk = async () => {
    try {
      const response = await axios.put(`${API}/risk`, {
        max_trade_usdt: Number(risk.max_trade_usdt),
        daily_loss_limit_usdt: Number(risk.daily_loss_limit_usdt),
        manual_confirmation: true,
        allowed_symbols: SYMBOLS,
      });
      setDashboard((current) => ({ ...current, risk: response.data }));
      setOrderMessage("Risk limits saved.");
    } catch (err) {
      setOrderMessage(apiErrorMessage(err, "Risk limits could not be saved."));
    }
  };

  return { botBusy, toggleBot, saveRisk };
}